import React from 'react';
const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      {/* Hexagon with fill */}
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#0f3f0f"
        d="M 50, 5
           L 11, 27
           L 11, 72
           L 50, 95
           L 89, 73
           L 89, 28 z"
      />

      {/* Letter E made with simple rectangles */}
      <g id="E" fill="var(--lightest-navy)">
        {' '}
        {/* White letter on colored background */}
        {/* Vertical bar of E */}
        <rect x="40" y="30" width="4" height="36" />
        {/* Top horizontal bar */}
        <rect x="40" y="30" width="16" height="4" />
        {/* Middle horizontal bar */}
        <rect x="40" y="46" width="12" height="4" />
        {/* Bottom horizontal bar */}
        <rect x="40" y="62" width="16" height="4" />
      </g>
    </g>
  </svg>
);
export default IconLoader;
